export default {"src":"/_next/static/media/apps-icon.abb45adb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};